module.exports = (View) => View.extend({
    initialize(config) {
        this.updateDomSelectorsToCache();
        View.prototype.initialize.call(this, config);
    },
    updateDomSelectorToCache(selector) {
        this.$cachedSelectors[selector] = this.$el.find(this.selectors[selector]);
    },
    updateDomSelectorsToCache(selectors = []) {
        selectors = selectors.length ? selectors : this.selectors;
        this.$cachedSelectors = Odigeo._.extend(this.$cachedSelectors || {}, Odigeo._.reduce(selectors, (cachedSelectors, selector, name) => {
            cachedSelectors[name] = this.$el.find(selector);
            return cachedSelectors;
        }, {}));
    },
});
